/* ============
 * Patient Util
 * ============
 */

export default {
  name(patient) {
    let fullName = patient.firstname;
    if (patient.lastname) {
      fullName += ` ${patient.lastname}`;
    }
    return fullName;
  },
};
